import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import type { Content } from '../content/types';
type Props = {
  content: Content['hero'];
};
export function Hero({
  content
}: Props) {
  return <section className="bg-brand-dark flex items-start pt-1 pb-16 sm:pt-2 sm:pb-20 lg:pt-2 lg:pb-28 px-5 sm:px-6 md:px-12 lg:px-24" data-id="element-30">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-20 items-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start space-y-6 sm:space-y-8" data-id="element-32">
          <h1 className="text-[34px] leading-[1.15] sm:text-[44px] sm:leading-[1.1] lg:text-[64px] font-bold text-brand-cream" data-id="element-33">
            {content.h1}
          </h1>

          <p className="text-[17px] sm:text-[20px] lg:text-[22px] text-brand-cream/85 leading-relaxed max-w-xl" data-id="element-34">
            {content.subtitle}
          </p>

          <div className="flex flex-col items-start space-y-4 w-full sm:w-auto pt-2 sm:pt-4" data-id="element-35">
            <a href={content.ctaHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-brand-gold text-brand-black font-bold text-[15px] sm:text-[16px] px-6 sm:px-8 py-4 rounded-[4px] hover:bg-white transition-colors duration-300 w-full sm:w-auto group" data-id="element-36">
              <ArrowRight className="w-5 h-5 mr-2 group-hover:translate-x-1 transition-transform" data-id="element-37" />
              {content.cta}
            </a>

            <div className="flex flex-col space-y-1" data-id="element-38">
              <p className="text-[13px] text-brand-gold italic" data-id="element-39">
                {content.note}
              </p>
              <p className="text-[13px] text-brand-cream/60" data-id="element-40">
                {content.availability}
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-full aspect-square lg:aspect-[4/5] max-w-md mx-auto lg:max-w-none" data-id="element-41">
          <div className="absolute inset-0 bg-brand-gold/10 rounded-2xl -translate-x-4 translate-y-4" data-id="element-42"></div>
          <img src="https://cdn.magicpatterns.com/uploads/6fi6XHCgsiCq1i26BwEvxd/LOGO_PHOTO_REBECA.png" alt="Rebeca Oliveira - Visibilia" className="relative w-full h-full object-cover rounded-2xl shadow-2xl" data-id="element-43" />
        </motion.div>
      </div>
    </section>;
}